export default {
  "src": [
    "./dist/soundsprites.ogg",
    "./dist/soundsprites.m4a",
    "./dist/soundsprites.mp3",
    "./dist/soundsprites.ac3"
  ],
  "sprite": {
    "back_to_start_1": [
      0,
      3223.9909297052154
    ],
    "back_to_start_2": [
      5000,
      2703.6507936507937
    ],
    "back_to_start_3": [
      9000,
      2428.1859410430843
    ],
    "bird": [
      13000,
      17766.009070294785
    ],
    "bump-top-1": [
      32000,
      226.82539682539726
    ],
    "bump_head_hurts": [
      34000,
      5152.018140589568
    ],
    "climb_up_dont_leave": [
      41000,
      9791.723356009072
    ],
    "comfy_wall": [
      52000,
      8364.53514739229
    ],
    "dont_step_on_snakes": [
      62000,
      5243.514739229027
    ],
    "ending": [
      69000,
      45710.13605442177
    ],
    "fell_to_start_1": [
      116000,
      5087.800453514746
    ],
    "fell_to_start_2": [
      123000,
      4576.258503401363
    ],
    "fell_to_start_3": [
      129000,
      4303.741496598633
    ],
    "fell_to_start_4": [
      135000,
      4407.188208616788
    ],
    "fly": [
      141000,
      1113.4693877550887
    ],
    "got_over_pit": [
      144000,
      10623.741496598654
    ],
    "hey_buddy": [
      156000,
      18010.7029478458
    ],
    "huge_fall": [
      176000,
      3216.8480725623567
    ],
    "ice_cream": [
      181000,
      2795.351473922892
    ],
    "jump1": [
      185000,
      300.5895691609908
    ],
    "ledge1_clue": [
      187000,
      7710.544217687073
    ],
    "love_wall": [
      196000,
      1944.6712018140602
    ],
    "love_wall_left": [
      199000,
      3182.3129251700666
    ],
    "love_wall_right": [
      204000,
      2316.1678004535133
    ],
    "piano_a0": [
      208000,
      1010.0680272108775
    ],
    "piano_a1": [
      211000,
      1102.9478458049766
    ],
    "piano_a2": [
      214000,
      1126.1678004535156
    ],
    "piano_a3": [
      217000,
      966.5306122448953
    ],
    "piano_a4": [
      219000,
      1010.0680272108775
    ],
    "piano_a5": [
      222000,
      641.45124716552
    ],
    "piano_a6": [
      224000,
      439.7278911564513
    ],
    "rocks_1": [
      226000,
      1453.4240362811772
    ],
    "slip-1": [
      229000,
      533.3786848072464
    ],
    "snarl": [
      231000,
      10749.455782312936
    ],
    "sounds": [
      243000,
      2303.900226757378
    ],
    "step-1": [
      247000,
      161.45124716553028
    ],
    "wall-touch-1": [
      249000,
      3843.1519274376456
    ],
    "why_climb": [
      254000,
      6509.160997732408
    ],
    "wind": [
      262000,
      5732.539682539709
    ],
    "wow_ledge": [
      269000,
      15900.181405895693
    ]
  }
}